// ESTADOS PARA HOME
export const dataTorneo = state => state.dataTorneo
export const dataCompetition = state => state.dataCompetition
export const modalidadTorneo = state => state.modalidadTorneo
export const globalMatches = state => state.globalMatches // para compartir de forma global el array de partidos en muchos componentes
export const globalStadiums = state => state.globalStadiums
export const globalJornadas = state => state.globalJornadas
export const globalFixture = state => state.globalFixture